import React from 'react';
import { X } from 'lucide-react';

interface AboutDialogProps {
  isOpen: boolean;
  onClose: () => void;
}

function AboutDialog({ isOpen, onClose }: AboutDialogProps) {
  if (!isOpen) return null;

  const sessionId = localStorage.getItem("sessionID") || 'Not available';

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-xl p-6 w-full max-w-md">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-semibold text-gray-900">About Barker</h2>
          <button 
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700"
          >
            <X size={20} />
          </button>
        </div>
        
        <div className="flex flex-col items-center space-y-6">
          {/* App Icon */}
          <div className="w-24 h-24 bg-gray-100 rounded-xl overflow-hidden shadow-md">
            <img 
              src="/assets/BarkingDogred.png"
              alt="Barker App Icon"
              className="w-full h-full object-cover"
            />
          </div>
          
          <div className="text-center space-y-4 text-gray-600">
            <div className="space-y-1">
              <h3 className="text-xl font-semibold text-gray-900">Barker</h3>
              <p className="text-sm text-gray-500">Voice-Controlled Sequence Player</p>
            </div>
            
            <div className="space-y-2">
              <p>© XR Media Group 2025</p>
              <p>
                Support Contact:{' '}
                <a 
                  href="mailto:lance@xrmediagroup.com" 
                  className="text-blue-600 hover:text-blue-800"
                >
                  lance@xrmediagroup.com
                </a>
              </p>
              <p>Author: Lance Van Nostrand</p>
              <div className="mt-4 pt-4 border-t border-gray-200">
                <p className="text-sm text-gray-500">
                  Device ID:{' '}
                  <span className="font-mono text-gray-700">
                    {sessionId}
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AboutDialog;